import { usePartnerInfo } from "@/api/services/main/partner";
import { LoadingPage } from "@/components/elements/Loading/Loading";
import { PartnerForm } from "@/features/partner/components/PartnerForm";
import { TPartnerForm } from "@/features/talent/types/partnerForm";
import { useValidateId } from "@/hooks/useValidateId";
import { AppRoutes } from "@/routes/config";

export const PartnerEditPage = () => {
  const queryResult = usePartnerInfo();
  const { data, isLoading } = queryResult;
  useValidateId("partnerId", AppRoutes.partnerList, queryResult);

  if (!data || isLoading) return <LoadingPage />;

  const partner = data.data;
  const defaultValues: Partial<TPartnerForm> = {
    id: partner.id,
    managementNumber: partner.managementNumber ?? null,
    partnerName: partner.partnerName ?? "",
    nationalityId: partner.nationalityId,
    sendingOrganization: partner.sendingOrganization ?? false,
    laborBureauStatus: partner.laborBureauStatus ?? false,
    zipCode: partner.zipCode ?? null,
    prefecture: partner.prefecture ?? null,
    city: partner.city ?? null,
    address: partner.address ?? null,
    location: partner.location ?? null,
    contactPerson: partner.contactPerson ?? null,
    contactMethod: partner.contactMethod ?? null,
    phoneNumber: partner.phoneNumber ?? null,
    email: partner.email ?? null,
    otherContacts: partner.otherContacts ?? null,
    contractInfo: partner.contractInfo ?? null,
    billingInfo: partner.billingInfo ?? null,
    memo: partner.memo ?? null,
  };

  return (
    <PartnerForm
      defaultValues={defaultValues}
      managementNumber={partner.managementNumber}
      createdAt={partner.createdAt}
      updatedAt={partner.updatedAt}
    />
  );
};
